/* istanbul ignore file */
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage, QuotePage } from 'premier-capability-policyjob-react';
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
import CoverablesPage from './pages/Coverables/CoverablesPage';
import SingleCoverablePage from './pages/Coverables/SingleCoverablePage';
import CoveragesPage from './pages/Coverages/CoveragesPage';
import ExposuresPage from './pages/Exposures/ExposuresPage';
import InfoPage from './pages/Info/InfoPage';
import QuestionsPage from './pages/Questions/QuestionsPage';
import MarPlePage from './pages/MarPle/MarPlePage';
import BoatsPage from './pages/Boats/BoatsPage';
import OperatorsPage from './pages/Operators/OperatorsPage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierPLPolicyDetailsPage: { component: 'PremierPLPolicyDetailsPage' },
        PremierPLDeclarationPage: { component: 'PremierPLDeclarationPage' },
        PremierOfferingsPage : { component: 'PremierOfferingsPage'},
        PremierPLLocationsPage : { component: 'PremierPLLocationsPage'},
        PremierRMInfoPage: { component: 'PremierRMInfoPage' },
        PremierRMQuestionsPage: { component: 'PremierRMQuestionsPage' },
        PremierRMSingleCoverablePage: { component: 'PremierRMSingleCoverablePage' },
        PremierRMExposuresPage: { component: 'PremierRMExposuresPage' },
        PremierRMCoveragesPage: { component: 'PremierRMCoveragesPage' },
        PremierRMCoverablesPage: { component: 'PremierRMCoverablesPage' },
        PremierRMQuotePage: { component: 'PremierRMQuotePage' },
        PremierPLRiskAnalysisPage: { component: 'PremierPLRiskAnalysisPage' },
        PremierRMPolicyInfoPage: { component: 'PremierRMPolicyInfoPage' },
        PremierRMSuccessPage: { component: 'PremierRMSuccessPage' },
        PremierRMMarPlePage: { component: 'PremierRMMarPlePage' },
        PremierRMBoatsPage: { component: 'PremierRMBoatsPage' },
        PremierRMOperatorsPage: { component: 'PremierRMOperatorsPage' },
    },
    {
        // wizard pages
        PremierPLPolicyDetailsPage: PolicyDetailsPage,
        PremierPLDeclarationPage: DeclarationPage,
        PremierOfferingsPage: OfferingsPage,
        PremierPLLocationsPage: LocationsPage,
        PremierRMInfoPage: InfoPage,
        PremierRMQuestionsPage: QuestionsPage,
        PremierRMSingleCoverablePage: SingleCoverablePage,
        PremierRMExposuresPage: ExposuresPage,
        PremierRMCoveragesPage: CoveragesPage,
        PremierRMCoverablesPage: CoverablesPage,
        PremierRMQuotePage: QuotePage,
        PremierRMPolicyInfoPage: PolicyInfoPage,
        PremierRMSuccessPage: SuccessPage,
        PremierPLRiskAnalysisPage: RiskAnalysisPage,
        PremierRMMarPlePage: MarPlePage,
        PremierRMBoatsPage: BoatsPage,
        PremierRMOperatorsPage: OperatorsPage,
    }
);
 
export { CodegenWizard, CodegenContext };
